import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { maintenance, updatemaintenance } from './api';

const initialState = {
  current: null,
  currentReceivedAt: 0,
  getCurrentLoading: false,
  history: [],
  pagination: {},
  getHistoryLoading: false,
  updateLoading: false
};

const actions = {
  GET_CURRENT: 'maintenance/GET_CURRENT',
  GET_HISTORY: 'maintenance/GET_HISTORY',
  START_MAINTENANCE: 'maintenance/START_MAINTENANCE',
  EXTEND_MAINTENANCE: 'maintenance/EXTEND_MAINTENANCE',
  END_MAINTENANCE: 'maintenance/END_MAINTENANCE'
};

export const getMaintenanceCurrent = createAsyncThunk(
  actions.GET_CURRENT,
  async (payload) => {
    const response = await maintenance('current', payload);

    // When seconds_remaining was measured — the page counts down from here.
    return { ...response, received_at: Date.now() };
  }
);

export const getMaintenanceHistory = createAsyncThunk(
  actions.GET_HISTORY,
  async (payload) => {
    const response = await maintenance('history', payload);

    return response;
  }
);

export const startMaintenance = createAsyncThunk(
  actions.START_MAINTENANCE,
  async (payload) => {
    const response = await updatemaintenance('start', payload);

    return response;
  }
);

export const extendMaintenance = createAsyncThunk(
  actions.EXTEND_MAINTENANCE,
  async (payload) => {
    const response = await updatemaintenance('extend', payload);

    return response;
  }
);

export const endMaintenance = createAsyncThunk(
  actions.END_MAINTENANCE,
  async (payload) => {
    const response = await updatemaintenance('end', payload);

    return response;
  }
);

const showResult = (payload) => {
  if (payload?.success) {
    message.success(payload?.message);
  } else {
    message.error(payload?.message || 'Something went wrong');
  }
};

export const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMaintenanceCurrent.pending, (state) => {
        state.getCurrentLoading = true;
      })
      .addCase(getMaintenanceCurrent.fulfilled, (state, action) => {
        const {
          success,
          data,
          received_at,
          message: msg
        } = action.payload || {};
        state.getCurrentLoading = false;
        if (success) {
          state.current = data;
          state.currentReceivedAt = received_at;
        } else {
          message.error(msg);
        }
      })
      .addCase(getMaintenanceCurrent.rejected, (state, action) => {
        state.getCurrentLoading = false;
        message.error(action.error.message);
      });

    builder
      .addCase(getMaintenanceHistory.pending, (state) => {
        state.getHistoryLoading = true;
      })
      .addCase(getMaintenanceHistory.fulfilled, (state, action) => {
        const {
          success,
          data,
          pagination,
          message: msg
        } = action.payload || {};
        state.getHistoryLoading = false;
        if (success) {
          state.history = data;
          state.pagination = pagination || null;
        } else {
          message.error(msg);
        }
      })
      .addCase(getMaintenanceHistory.rejected, (state, action) => {
        state.getHistoryLoading = false;
        message.error(action.error.message);
      });

    [startMaintenance, extendMaintenance, endMaintenance].forEach((thunk) => {
      builder
        .addCase(thunk.pending, (state) => {
          state.updateLoading = true;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state.updateLoading = false;
          showResult(action.payload);
        })
        .addCase(thunk.rejected, (state, action) => {
          state.updateLoading = false;
          message.error(action.error.message);
        });
    });
  }
});

export default maintenanceSlice.reducer;
